// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tD3O","comment":"styles_comment__1f0MK"};